module.exports = __webpack_public_path__ + "img/img_charge_phone_img3.8cfd0a67.png";